<template>
  <div>
    <el-container>

      <el-main v-loading="loading">
        <el-row>
          <el-col :span="22"
                  :offset="1">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }"><i class="iconfont">&#xe60b;</i>&nbsp;返回首页</el-breadcrumb-item>
              <el-breadcrumb-item>
                非上市公司感知
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <br> <br>
          <el-col :span="22"
                  :offset="1"
                  class="whiteContainer">
            <template>
              <el-tabs v-model="tabsName">
                <el-tab-pane label="非上市公司感知"
                             name="data">
                  <data2 />
                </el-tab-pane>
              </el-tabs>
            </template>
          </el-col>
        </el-row>
      </el-main>

    </el-container>

  </div>
</template>

<script>

import data2 from '../components/index/data'

export default {
  name: 'ele',
  data: function () {
    return {
      loading: false,
      tabsName: 'data',
      conceptDialogVisible: false,
      conceptSearchLogs: [],
      curReport: {}

    }
  },
  filters: {

  },
  components: {
    data2
  },
  computed: {

  },
  watch: {

  },

  methods: {

  },

  mounted () {

  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/index2.vue